/**
 * ファイルのアップロード
 * @returns { void }
 */
export const fileUpload = () => {
  const element  = document.querySelector( '.p-form-item__file' );
  const input    = document.querySelector( '.p-form-item__file input' );
  const fileList = document.querySelector( '.p-form-item__files' );
  const form     = document.querySelector( 'form.p-form' );
  let   files    = '';
  toggleCheck();

  /**
   * ファイルドラッグオンで枠線を太く青く変化させる
   */
  element.addEventListener( 'dragover', () => {
    element.style.borderColor = '#3937BA';
    element.style.borderWidth = '2px';

  /**
   * ファイルドラッグリーブで枠線を戻す
   */
    element.addEventListener( 'dragleave', () => {
      element.style.borderColor = '#CCCCCC';
      element.style.borderWidth = '1px';
    } );

    /**
     * ファイルドロップで枠線を戻す
     */
    element.addEventListener( 'drop', () => {
      element.style.borderColor = '#CCCCCC';
      element.style.borderWidth = '1px';
    } );
  } );

  /**
   * アップロードしたファイル名を一覧出力
   */
  input.addEventListener( 'change', ( event ) => {
    const fileName = event.srcElement.files[0].name;
    const addHtml  = `<div class="p-form-item__files-item">
                        <a href="javascript:void(0)" class="delete c-icon c-icon--delete"></a>
                        <a href="#" class="link p-link-text">${ fileName }</a>
                      </div>`;
    fileList.innerHTML += addHtml;
    event.target.value = '';
    files = document.querySelectorAll( '.p-form-item__files-item' );
    toggleCheck();

      /**
       * アップロードしたファイルを削除
       */
      files.forEach( file => {
        const deleteButton = file.querySelector( '.delete' );
        deleteButton.addEventListener( 'click', () => {
          file.remove();
          toggleCheck();
        } );
      } );
  } );

  input.addEventListener( 'focusout', () => {
    toggleCheck();
  } );

  form.addEventListener( 'change', () => {
    toggleCheck();
  } );

  form.addEventListener( 'focusout', () => {
    toggleCheck();
  } );
}

const toggleCheck = () => {
  const files  = document.querySelectorAll( '.p-form-item__files-item' );
  const check  = document.querySelector( '.p-form-item.is--file .p-form-item__status-icon' );
  const button = document.querySelector( '.p-agreement__button input[type="submit"]' );
  const counter= document.querySelector( '.js-counterNum' );

  if ( files.length ) {
    check.classList.add( 'c-icon--success' );
    check.classList.remove( 'c-icon--success-off' );
    button.removeAttribute( 'disabled' );
    counter.textContent = 0;
  } else {
    check.classList.add( 'c-icon--success-off' );
    check.classList.remove( 'c-icon--success' );
    button.setAttribute( 'disabled', null );
    counter.textContent = 1;
  }
}
